// extracted by mini-css-extract-plugin
export var root = "BaseLayout-module--root--Ocr0c";
export var isFixedHeader = "BaseLayout-module--isFixedHeader--3xiMv";
export var noise = "BaseLayout-module--noise--13GSv";
export var grain = "BaseLayout-module--grain--24dW7";